<script lang="ts">
  import ChevronLeft from 'lucide-svelte/icons/chevron-left';
  import ChevronRight from 'lucide-svelte/icons/chevron-right';
  import * as Pagination from '$lib/components/ui/pagination/index.js';

  interface Props {
    totalItems: number;
    currentPage?: number;
    itemsPerPage?: number;
    siblingCount?: number;
    onPageChange?: (page: number) => void;
  }

  let isDesktop = $state(false);

  $effect(() => {
    if (typeof window === 'undefined') return;

    isDesktop = window.matchMedia('(min-width: 768px)').matches;

    const mediaQuery = window.matchMedia('(min-width: 768px)');
    const updateIsDesktop = (e: MediaQueryListEvent) => {
      isDesktop = e.matches;
    };

    mediaQuery.addEventListener('change', updateIsDesktop);
    return () => mediaQuery.removeEventListener('change', updateIsDesktop);
  });

  let {
    totalItems,
    currentPage = 1,
    itemsPerPage = 10,
    siblingCount: defaultSiblingCount = 1,
    onPageChange
  }: Props = $props();

  let siblingCount = $derived(isDesktop ? defaultSiblingCount : 0);

  function handlePageChange(newPage: number) {
    if (onPageChange) {
      onPageChange(newPage);
    }
  }
</script>

<Pagination.Root
  count={totalItems}
  perPage={itemsPerPage}
  {siblingCount}
  page={currentPage}
  onPageChange={handlePageChange}
  let:pages
  let:currentPage
>
  <Pagination.Content>
    <Pagination.Item>
      <Pagination.PrevButton>
        <ChevronLeft class="h-4 w-4" />
      </Pagination.PrevButton>
    </Pagination.Item>

    {#each pages as page (page.key)}
      {#if page.type === 'ellipsis'}
        <Pagination.Item>
          <Pagination.Ellipsis />
        </Pagination.Item>
      {:else}
        <Pagination.Item>
          <Pagination.Link {page} isActive={currentPage === page.value}>
            {page.value}
          </Pagination.Link>
        </Pagination.Item>
      {/if}
    {/each}

    <Pagination.Item>
      <Pagination.NextButton>
        <ChevronRight class="h-4 w-4" />
      </Pagination.NextButton>
    </Pagination.Item>
  </Pagination.Content>
</Pagination.Root>
